"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import { NavUser } from "./nav-user";
import { UserOrNot } from "./user-or-not";
import { ThemeSwitcher } from "./theme-switcher";

export function LoginOrUserDesktop() {
  return (
    <UserOrNot
      userContent={(user) => <NavUser user={user} />}
      noUserContent={
        <div className="flex items-center gap-4 justify-center animate-in fade-in duration-500">
          <div className="text-gray-700 dark:text-gray-300">
            <ThemeSwitcher />
          </div>
          <Button asChild>
            <Link href="/c/cloud/api-keys">Log in / Sign up</Link>
          </Button>
        </div>
      }
    />
  );
}
